export default __webpack_public_path__ + "static/media/Dashmesh.6a0dc3ee.png";